const normalizeValue = (value: any): any => {
  if (value === null || value === undefined) return null;
  if (Array.isArray(value)) return value.map(normalizeValue);
  if (typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value)
        .filter(([, v]) => v !== null && v !== undefined)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([k, v]) => [k, normalizeValue(v)]),
    );
  }
  if (typeof value === "string" && value.trim() !== "") {
    const num = Number(value);
    if (!isNaN(num)) return num;
  }
  return value;
};

const isEqual = (original: any, to: any): boolean => {
  if (original === to) return true;
  if (!original || !to) return false;
  return (
    JSON.stringify(normalizeValue(original)) ===
    JSON.stringify(normalizeValue(to))
  );
};

export default isEqual;
